import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DefaultLayoutComponent } from './containers';
import { P404Component } from './views/error/404/404.component';
import { LoginComponent } from './views/login/login.component';
import { AuthGuard } from './core/auth.guard';
import { P403Component } from './views/error/403/403.component';
import { ForgotPasswordComponent } from './views/forgot-password/forgot-password.component';
import { SsoLoginComponent } from './views/sso-login/sso-login.component';

export const routes: Routes = [
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
        canActivate: [AuthGuard]
      },
      {
        path: 'region',
        loadChildren: () => import('./components/master/master.module').then(m => m.MasterComponentModule)
      },
      {
        path: 'coupon',
        loadChildren: () => import('./components/coupon/coupon.module').then(m => m.CouponComponentModule),
      },
      {
        path: 'configuration',
        loadChildren: () => import('./components/configuration/configuration.module').then(m => m.ConfigurationComponentModule),
      },
      {
        path: 'notification',
        loadChildren: () => import('./components/notification-template/notification.module').then(m => m.NotificationTemplateModule),
      },
      {
        path: 'user',
        loadChildren: () => import('./components/user/user.module').then(m => m.UserModule),
      },

      {
        path: 'map-view',
        loadChildren: () => import('./components/map-view/map-view.module').then(m => m.MapViewModule),
      },
      {
        path: 'tickets',
        loadChildren: () => import('./components/tickets/tickets.module').then(m => m.TicketsModule),
      },
      {
        path: 'training',
        loadChildren: () => import('./components/training/training.module').then(m => m.TrainingModule),
      },
      {
        path: 'exams',
        loadChildren: () => import('./components/exam/exam.module').then(m => m.ExamModule),
      },
      {
        path: 'partner-appointment',
        loadChildren: () => import('./components/partner-appointment/partner-appointment.module').then(m => m.PartnerAppointmentModule),
      },
      {
        path: 'change-password',
        loadChildren: () => import('./components/change-password/change-password.module').then(m => m.ChangePasswordModule),
      },
      {
        path: 'profile',
        loadChildren: () => import('./components/profile/profile.module').then(m => m.ProfileModule),
      },

      {
        path: 'dashboard',
        loadChildren: () => import('./components/dashboard/dashboard.module').then(m => m.DashboardModule),
      },
      {
        path: 'order',
        loadChildren: () => import('./components/order/order.module').then(m => m.OrderModule),
      },
      {
        path: 'reviews-rating',
        loadChildren: () => import('./components/reviews-ratings/reviews-ratings.module').then(m => m.ReviewsRatingsModule),
      },

      {
        path: 'transaction',
        loadChildren: () => import('./components/transaction/transaction.module').then(m => m.TransactionModule),
      },
      {
        path: 'health',
        loadChildren: () => import('./components/health/health.module').then(m => m.HealthModule),
      },
      {
        path: 'language',
        loadChildren: () => import('./components/language-configuration/language-configuration.module').then(m => m.LanguageConfigurationModule),
      },
      {
        path : 'help',
        loadChildren : () => import('./components/help/help.module').then(m => m.HelpModule)
      },
      {
        path : 'promotion',
        loadChildren : () => import('./components/promotion/promotion.module').then(m => m.PromotionModule)
      },
      {
        path : 'productivity',
        loadChildren : () => import('./components/productivity/productivity.module').then(m => m.ProductivityModule)
      },
      {
        path : 'online-partners',
        loadChildren : () => import('./components/online-partners/online-partners.module').then(m => m.OnlinePartnersModule)
      },
      {
        path: 'banner-management',
        loadChildren: () => import('./components/banner-management/banner-management.module').then(m => m.BannerManagementModule),
      },
      {
        path: 'deleted-users',
        loadChildren: () => import('./components/deleted-users/deleted-users.module').then(m => m.DeletedUserModule),
      },
      {
        path: 'referral-configuration',
        loadChildren: () => import('./components/referral-configuration/referral-configuration.module').then(m => m.ReferralConfigurationModule),
      },
      {
        path:'report',
        loadChildren:()=> import ('./components/reports/reports.module').then(m => m.ReportsModule)
      }
    ]
  },
  {
    path: 'public',
    children: [
      {
        path: 'order',
        children: [
          {
            path: 'view-ride',
            loadChildren: () => import('./components/order/ride-list/view-ride-un-auth/view-ride-un-auth.module')
              .then(m => m.ViewRideUnAuthModule),
          },
          {
            path: 'list-of-orders',
            loadChildren: () => import('./components/order/list-of-orders/list-of-orders.module')
              .then(m => m.ListOfOrdersModule),
          },
          {
            path: 'view-order-group',
            loadChildren: () => import('./components/order/order-group/view-order-group-un-auth/view-order-group-un-auth.module')
              .then(m => m.ViewOrderGroupUnAuthModule),
          },
        ]
      }
    ]
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '403-error',
    component: P403Component,
    data: {
      title: 'Page 403'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'sso-login',
    component: SsoLoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: '**', component: P404Component
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
